import http from './http' // needs this file in the same directory

export default {
  index(){
    return http.get(`/users`);
  },

  show(item_id){
    return http.get(`/users/`+item_id);
  },

  profile(item_id){
    return http.get(`/user`);
  },

  create(new_item){
    return http.post(`/users`,{
      user:{ 
        name: new_item.name,
        email: new_item.email,
        cpf: new_item.cpf,
        salary: new_item.salary,//.replace(/,/g, ''),
        phones: new_item.phones,//.split(','),
        address: new_item.address,
        password: 123456, // new_item.password,
        password_confirmation: 123456, //new_item.password_confirmation,
        role_ids: new_item.role_ids
      }
    });
  },

  update(update_item){
    return http.put(`/users/${update_item.id}`,{
      user:{ 
        id: update_item.id,

        name: update_item.name,
        email: update_item.email,
        cpf: update_item.cpf,
        salary: update_item.salary,//.replace(/,/g, ''),
        phones: update_item.phones,//.split(','),
        addresses: update_item.address,

        password: update_item.password,
        password_confirmation: update_item.password_confirmation,
        
        role_ids: update_item.role_ids
      }
    });
  },

  updateToDelete(update_item){
    return http.delete(`/users/${update_item}`);
  },

}